/**
 * Portcierge does not accept connection invites in-place (API CORS is for
 * wanderertrip.com). Hand off to the consumer web accept URL.
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Spin, Typography } from 'antd';
import { inviteCopyEn } from '../../content/invite.en';
import { consumerInviteAcceptUrl } from '../../utils/consumerWebOrigin';
import styles from './Invite.module.css';

const { Title, Paragraph } = Typography;

const InviteAccept: React.FC = () => {
  const { inviteId: rawInviteId } = useParams<{ inviteId: string }>();
  const inviteId = rawInviteId?.trim() || '';
  const target = inviteId ? consumerInviteAcceptUrl(inviteId) : null;

  useEffect(() => {
    if (!target || typeof window === 'undefined') return;
    window.location.replace(target);
  }, [target]);

  if (!inviteId || !target) {
    return (
      <div className={styles.page}>
        <div className={styles.container}>
          <Title className={styles.title}>{inviteCopyEn.title}</Title>
          <Paragraph className={styles.lead}>{inviteCopyEn.notFound}</Paragraph>
          <Link className={styles.secondaryLink} to="/">
            {inviteCopyEn.acceptGoToTrips}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page} data-invite-id={inviteId}>
      <div className={styles.container}>
        <Spin size="large" tip={inviteCopyEn.acceptRedirecting} />
        <Paragraph className={styles.hint}>
          <a href={target}>{inviteCopyEn.acceptRedirectManual}</a>
        </Paragraph>
      </div>
    </div>
  );
};

export default InviteAccept;
